export class NetworkError extends Error {
  name = 'NetworkError';
  message: string;
  stack?: string;

  constructor({ message, cause, stack }: { message: string; cause?: unknown; stack?: string }) {
    super(message);
    this.message = message;
    this.cause = cause;
    if (stack) {
      this.stack = stack || undefined;
    }
  }

  toJSON() {
    return { message: this.message, stack: this.stack };
  }
}

export function isNetworkError(error: unknown): error is NetworkError {
  return error instanceof NetworkError;
}
